import { render, staticRenderFns } from "./rankCate.vue?vue&type=template&id=77e52141&"
import script from "./rankCate.vue?vue&type=script&lang=js&"
export * from "./rankCate.vue?vue&type=script&lang=js&"
import style0 from "./rankCate.vue?vue&type=style&index=0&id=77e52141&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports